// extracted by mini-css-extract-plugin
export default {"heading":"ShareIcon_heading__qMmNW","text":"ShareIcon_text__EVXuY","row":"ShareIcon_row__6bHQV"};